//
if (document.querySelector('.recognised-suppliers') != null) {

    //
    const themeEmphasisMap = {
        'off-white'         : 'blue',
        'blue'              : 'orange',
        'featured-branded'  : 'blue',
        'orange'            : 'orange',
        'well'              : 'blue'
    }

    //
    const recognisedSuppliersContainers = document.querySelectorAll('section.container:has(div.recognised-suppliers)');

    //
    recognisedSuppliersContainers.forEach((container) => {

        //get the theme from the container
        let theme = container.dataset.theme || 'off-white';
        
        //handle wells
        theme = theme.startsWith('well') ? 'well' : theme;

        //change the theme of the button based on the emphasis colour of the theme
        const emphasisTheme = themeEmphasisMap[theme];
        container.querySelectorAll('.recognised-suppliers button').forEach((button) => { button.setAttribute('data-theme', emphasisTheme) });

    })
}  


//
document.querySelectorAll('.recognised-suppliers').forEach((recognisedSuppliersComponent) => {

    //
    const recognisedSuppliersFilter = recognisedSuppliersComponent.querySelector('.recognised-suppliers-filter');
    const recognisedSuppliersItems  = recognisedSuppliersComponent.querySelector('.recognised-suppliers-items');

    //update the displayed items when the "category" filter is applied
    recognisedSuppliersFilter.querySelector('select[name="category"]').addEventListener('change', (event) => {
        updateRecognisedSuppliers();
    });

    //
    updateRecognisedSuppliers();

    //
    function updateRecognisedSuppliers() {
        const selectedOption = recognisedSuppliersFilter.querySelector('select[name="category"]').querySelector('option:checked');
        recognisedSuppliersItems.querySelectorAll('.supplier').forEach((supplier) => {
            supplier.classList.toggle('hidden', !(selectedOption === null || selectedOption.value === '' || supplier.dataset.category === selectedOption.value));
        });
    };

    //before running our own logic, see if the browser supports the masonary spec, if not - then get to work!
    if (!CSS.supports('grid-template-rows', 'masonry')) {

        //
        recognisedSuppliersItems.setAttribute('data-masonry', 'active');

        //wrap the children of each "supplier" in a container - will use this to calculate the deired supplier height later
        Array.from(recognisedSuppliersItems.children).forEach((supplier) => {
            const container = document.createElement('div');
            Array.from(supplier.children).forEach((element) => {
                container.appendChild(element);
            });
            supplier.appendChild(container);
        });

        //resize a single supplier in the recognisedSuppliersItems
        const resizeSupplier = (supplier) => {

            //get the height of each row, and the gap
            rowHeight = parseInt(window.getComputedStyle(recognisedSuppliersItems).getPropertyValue('grid-auto-rows'));
            rowGap    = parseInt(window.getComputedStyle(recognisedSuppliersItems).getPropertyValue('grid-row-gap'));

            //calculate how many grid rows the supplier spans, based on the height of the immediate child (we should only have one!)
            supplier.style.gridRowEnd = `span ${Math.ceil((supplier.children[0].getBoundingClientRect().height + rowGap) / (rowHeight + rowGap))}`;
        }

        //use a resize observer to pick on anytime the suppler element change size (images loads/viewport changes etc)
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                resizeSupplier(entry.target.closest('.supplier'));
            }
        });

        //resize all the suppliers in the recognisedSuppliersItems
        const resizeAllsuppliers = () => {
            Array.from(recognisedSuppliersItems.children).forEach((supplier) => {
                resizeSupplier(supplier);
                resizeObserver.observe(supplier.children[0]);
            });
        }

        //run the initial resize on the next render frame
        setTimeout(() => resizeAllsuppliers(), 0);

    }

});